export { DMS_MODULE } from '../../constants';

export const NAME = 'ReverseJobOrder';
export const CRUMB_LABEL_KEY = 'ReverseJobOrder';
export const REVERSE_JOB_ORDER = 'ReverseJobOrder';
export const DEPENDENT_TABLES_ALL = <const>[
	REVERSE_JOB_ORDER,
];
export const STATUS_APPROVED = 1;
export const STATUS_REJECTED = 3;
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];
